import { render, staticRenderFns } from "./travelers-details-form.vue?vue&type=template&id=4ed002f4&scoped=true&"
import script from "./travelers-details-form.vue?vue&type=script&lang=js&"
export * from "./travelers-details-form.vue?vue&type=script&lang=js&"
import style0 from "./travelers-details-form.vue?vue&type=style&index=0&id=4ed002f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed002f4",
  null
  
)

export default component.exports